/** Format a score breakdown range for display. */
export function formatScoreBandRange(item) {
  const from =
    item?.score_from !== "" && item?.score_from != null
      ? Number(item.score_from)
      : null;
  const to =
    item?.score_to !== "" && item?.score_to != null
      ? Number(item.score_to)
      : null;

  if (from === null) return "";
  if (to === null || Number.isNaN(to)) return `${from}+`;
  return `${from} – ${to}`;
}

/** Map API score_breakdown rows to CcScoreBand `bands`. */
export function mapScoreBreakdownToBands(scoreBreakdown = []) {
  return scoreBreakdown.map((item, index) => ({
    key: item.id ?? `band-${index}`,
    label: item.label || item.category || "",
    range: formatScoreBandRange(item),
    scoreFrom:
      item.score_from !== "" && item.score_from != null
        ? Number(item.score_from)
        : null,
    scoreTo:
      item.score_to !== "" && item.score_to != null
        ? Number(item.score_to)
        : null,
  }));
}

/** Resolve which band key matches the current numeric score. */
export function getActiveScoreBandKey(score, bands = []) {
  if (score === null || score === undefined) return null;

  const match = bands.find((band) => {
    if (band.scoreFrom === null) return false;
    return (
      score >= band.scoreFrom &&
      (band.scoreTo === null || score <= band.scoreTo)
    );
  });

  return match?.key ?? null;
}
